module.exports = __webpack_public_path__ + "static/media/textile_cad_01.445533f9.jpg";